import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { useDocOverflowDetection } from '@common/composables/useDocOverflowDetection';
import { useUID } from '@common/composables/useUID';
import { computed, onMounted, ref, watch } from 'vue';
// Props
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDropdown',
  props: {
    closeOnClick: {
      type: Boolean,
      default: true
    },
    menuWidth: null,
    direction: {
      default: 'bottom'
    },
    minHeight: {
      default: 88
    },
    maxHeight: {
      default: 300
    },
    boundry: {
      default: 'scrollParent'
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  emits: ["show", "shown", "hide", "hidden"],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const uid = useUID('dropdown');
    const dropdown = ref();
    const menuEl = ref();
    const overflowEl = ref();
    const {
      docOverflow
    } = useDocOverflowDetection(menuEl, dropdown);
    const constrainedMaxHeight = ref(null);
    const dropdownClasses = computed(() => {
      const results = ['dropdown'];
      if (!props.block) results.push('d-inline-block');
      if (props.direction === 'left') results.push('dropleft');else if (props.direction === 'right') results.push('dropright');else if (props.direction === 'top') results.push('droptop');
      return results.join('; ');
    });
    const menuStyles = computed(() => {
      const results = [];
      if (props.menuWidth) {
        results.push(`width: ${props.menuWidth}px`);
      }
      results.push(`min-width: 100%`);
      return results.join('; ');
    });
    const sheetStyles = computed(() => {
      // Use the locked-in constrained height if set, otherwise use props.maxHeight
      let max = props.maxHeight;
      if (constrainedMaxHeight.value) max = constrainedMaxHeight.value > props.maxHeight ? props.maxHeight : constrainedMaxHeight.value;
      return `overflow-y: auto; max-height: ${max}px`;
    });
    const on = {};
    function toggleMenu(show) {
      if (typeof show === 'boolean') {
        if (show) bsDropdown.value.dropdown('show');else bsDropdown.value.dropdown('hide');
      }
      bsDropdown.value.dropdown('toggle');
    }
    const open = ref(false);
    const attrs = computed(() => ({
      'aria-expanded': open.value,
      'data-toggle': 'dropdown',
      'data-boundry': props.boundry
    }));
    const bsDropdown = computed(() => {
      const el = document.querySelector(`[data-uid="${uid}"] [data-toggle="dropdown"]`);
      return $(el);
    });
    // Watchers
    // Calculate constrained height once when menu opens and overflow is detected
    watch([open, docOverflow], ([open, overflow]) => {
      if (!open) {
        // Reset Scroll Position
        overflowEl.value?.scrollTo({
          top: 0
        });
        constrainedMaxHeight.value = null;
        return;
      }
      setConstrainedMaxHeight();
    }, {
      immediate: true
    });
    watch(constrainedMaxHeight, val => {
      setTimeout(() => bsDropdown.value.dropdown('update'));
    });
    watch(() => props.boundry, val => {
      bsDropdown.value.dropdown({
        boundary: val,
        display: val === 'viewport' ? 'static' : 'dynamic'
      });
    }, {
      immediate: true
    });
    const isFlipped = ref(false);
    onMounted(() => {
      (function init() {
        if (!dropdown.value) {
          setTimeout(init, 100);
          return;
        }
        // Proxy Bootstrap events
        $(dropdown.value).on('show.bs.dropdown', () => emit('show'));
        $(dropdown.value).on('shown.bs.dropdown', () => emit('shown'));
        $(dropdown.value).on('hide.bs.dropdown', () => emit('hide'));
        $(dropdown.value).on('hidden.bs.dropdown', () => emit('hidden'));
        // Your existing handlers
        $(dropdown.value).on('shown.bs.dropdown', () => {
          open.value = true;
        });
        $(dropdown.value).on('hidden.bs.dropdown', () => {
          open.value = false;
        });
        $(dropdown.value).on('shown.bs.dropdown', () => {
          open.value = true;
          setTimeout(() => {
            const actualPlacement = menuEl.value?.getAttribute('x-placement');
            isFlipped.value = !!(actualPlacement && !actualPlacement.startsWith(props.direction));
            setTimeout(setConstrainedMaxHeight, 10);
          }, 1);
        });
      })();
    });
    function setConstrainedMaxHeight() {
      const flips = {
        'top': 'bottom',
        'bottom': 'top',
        'left': 'right',
        'right': 'left'
      };
      constrainedMaxHeight.value = docOverflow.value.availableSpace[isFlipped.value ? flips[props.direction] : props.direction];
    }
    const opened = computed(() => open.value);
    expose({
      toggleMenu,
      opened
    });
    return {
      __sfc: true,
      props,
      emit,
      uid,
      dropdown,
      menuEl,
      overflowEl,
      docOverflow,
      constrainedMaxHeight,
      dropdownClasses,
      menuStyles,
      sheetStyles,
      on,
      toggleMenu,
      open,
      attrs,
      bsDropdown,
      isFlipped,
      setConstrainedMaxHeight,
      opened
    };
  }
});